/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Partner_Admin_Commission_Month_CommissionInputs */



/**
* | output |
* | --- |
* | "Commission at {rate}" |
*
* @param {Partner_Admin_Commission_Month_CommissionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_month_commission = /** @type {((inputs: Partner_Admin_Commission_Month_CommissionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Month_CommissionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Provision mit ${i?.rate}`)
	return /** @type {LocalizedString} */ (`Commission at ${i?.rate}`)
});